module.exports = __webpack_public_path__ + "img/biorrolo3.25c94fdf.png";